import z from "zod";

// TODO: Add actual error types for Secrets Manager external service
const secretsManagerErrorTypeValues = ["PLACEHOLDER_ERROR"] as const;

const secretsManagerErrorTypeSchema = z.enum(secretsManagerErrorTypeValues);
const SecretsManagerErrorType = secretsManagerErrorTypeSchema.enum;
type SecretsManagerErrorType = z.infer<typeof secretsManagerErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type SecretsManagerErrors = {
  errorType: typeof SecretsManagerErrorType.PLACEHOLDER_ERROR;
  // TODO: Add specific data fields for Secrets Manager errors
  data: Record<string, never>;
};

export const secretsManagerErrorDetails: Record<SecretsManagerErrorType, ErrorDetails> = {
  [SecretsManagerErrorType.PLACEHOLDER_ERROR]: {
    sentryDescription: "Secrets Manager external service error",
  },
};
